import validationEn from "@/js/locales/en/validation";
import validationRo from "@/js/locales/ro/validation";
import shopProductsRo from "@/js/locales/ro/shop_products";
import shopUpsellProductsRo from "@/js/locales/ro/shop_upsell_products";
import pageEventsRo from "@/js/locales/ro/page_events";
import webhookEventsRo from "@/js/locales/ro/webhook_events";
import shopOrdersRo from "@/js/locales/ro/shop_orders";
import shopOrderProductsRo from "@/js/locales/ro/shop_order_products";
import common from "@commonLang/messages";
import dexter from "@dexterLang/messages";
import dexnex from "@dexnexLang/messages";

export default {
    en: {
        ...common.en,
        ...dexter.en,
        ...dexnex.en,
        "validation": validationEn,
    },
    ro: {
        ...common.ro,
        ...dexter.ro,
        ...dexnex.ro,
        "validation": validationRo,
        "shop_products": shopProductsRo,
        "shop_upsell_products": shopUpsellProductsRo,
        "shop_orders": shopOrdersRo,
        "shop_order_products": shopOrderProductsRo,
        "page_events": pageEventsRo,
        "webhook_events": webhookEventsRo
    }
}
